import { Koi } from '@ksyos/koi';
import { getTextAreaStringSchema } from '../utils/getTextAreaStringSchema';

export const identifierSocialSecuritySchemaFinal = Koi.string().elfproef().required();
export const identifierSocialSecuritySchemaDraft = getTextAreaStringSchema(true, 255);
